import { Fragment } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getEntryUrlContext, getUrl
// @ts-expect-error module not typed
} from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { BlankIcon, InfoIcon } from 'foundations-assets';
import SystemMessage from 'conversations-inbox-message-history/system-message/SystemMessage';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error module not typed
import { editChatFlowDeepLink } from '../../../urls/editChatFlowDeepLink';
import { useChatflows } from 'conversations-thread-data/chatflows/hooks/useChatflows';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChatflowContextSystemUpdate = ({
  chatflowId,
  message,
  isFacebookChatflow,
  ungatedForThreadMessagesUIImprovements
}) => {
  const {
    asyncChatflow
  } = useChatflows({
    chatflowId
  });
  if (isLoading(asyncChatflow)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      inlineSize: "200px",
      use: "on-shade"
    });
  }
  const chatflow = getData(asyncChatflow);
  // @ts-expect-error does not exist on type
  const {
    channelInstance
  } = chatflow || {};
  const chatflowName = channelInstance && channelInstance.name || '';
  const getChatflowLink = () => /*#__PURE__*/_jsx(Link, {
    href: editChatFlowDeepLink({
      chatflowId
    }),
    external: true,
    use: "blue",
    truncate: true,
    maxInlineSize: "500px",
    truncateStringProps: {
      matchContentWidth: true,
      useFlex: false,
      tooltip: false
    },
    children: chatflowName
  });
  const getEntryUrl = entryUrl => {
    const url = getUrl(entryUrl);
    const linkLabel = isFacebookChatflow ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-thread-view.threadHistory.context-update-message.facebook.facebookLinkName"
    }) : url;
    const link = /*#__PURE__*/_jsx(Link, {
      href: url,
      external: true,
      use: "blue",
      truncate: true,
      truncateStringProps: {
        matchContentWidth: true,
        useFlex: false,
        tooltip: false
      },
      children: linkLabel
    });
    return /*#__PURE__*/_jsx(SystemMessage, {
      description: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        gap: "100",
        children: [/*#__PURE__*/_jsx(View, {
          flexShrink: 0,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "conversations-thread-view.threadHistory.context-update-message.chatflow.chatflowLinkLabel"
          })
        }), link]
      }),
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: "0",
        icon: BlankIcon,
        size: "500"
      }),
      ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
    });
  };
  const entryUrl = getEntryUrlContext(message);
  let linkText = null;
  let sourceText = /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-thread-view.threadHistory.context-update-message.unknownSourceMessage'
    }, 'chatflow-source-message'),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: InfoIcon,
      size: "500"
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
  if (chatflowName) {
    sourceText = /*#__PURE__*/_jsx(SystemMessage, {
      timestamp: getTimestamp(message),
      description: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        gap: "100",
        alignItems: "center",
        marginInlineEnd: "400",
        children: [/*#__PURE__*/_jsx(View, {
          flexShrink: 0,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: 'conversations-thread-view.threadHistory.context-update-message.chatflow.chatFlowSubmissionLabel',
            options: {
              chatflow: getChatflowLink()
            }
          }, 'chatflow-source-message')
        }), getChatflowLink()]
      }),
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: "0",
        icon: InfoIcon,
        size: "500"
      }),
      ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
    });
  }
  if (entryUrl) {
    linkText = getEntryUrl(entryUrl);
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: sourceText
    }), /*#__PURE__*/_jsx("div", {
      children: linkText
    })]
  });
};
ChatflowContextSystemUpdate.displayName = 'ChatflowContextSystemUpdate';
export default ChatflowContextSystemUpdate;